import React, { useEffect, useState } from 'react'
import { useLazyLoadQuery, graphql } from 'react-relay/hooks'
import { FlexColumn, ModalNavHeader } from 'elements'
import ChoiceButton from '../ui/input/ChoiceButton'
import ModalContent from '../app/ModalContent'
import useIntegrationUpdate from './hooks/useIntegrationUpdate'
import StandardModalFooter from '../app/StandardModalFooter'

export default function ConnectionChoices({ integrationRowId, onDone, onClose }) {
  const [selected, setSelected] = useState(null)
  const [updateIntegration, isInFlight] = useIntegrationUpdate()

  const { integration } = useLazyLoadQuery(
    graphql`
      query ConnectionChoicesQuery($integrationRowId: UUID!) {
        integration(rowId: $integrationRowId) {
          config
        }
      }
    `,
    { integrationRowId },
  )

  const configXero = integration?.config?.xero
  const tenants = configXero?.tenants

  useEffect(() => {
    if (tenants?.length) {
      setSelected(tenants[0])
    }
  }, [tenants, setSelected])

  if (!tenants) {
    return null
  }

  const handleContinue = async () => {
    const newConfig = { xero: { ...configXero, currentTenant: selected } }

    await updateIntegration({
      rowId: integrationRowId,
      patch: { config: newConfig },
    })

    onDone()
  }

  return (
    <>
      <ModalNavHeader titleText="Select a xero organization to connect" onClose={onClose} />
      <ModalContent>
        <FlexColumn>
          {tenants.map((tenant, idx) => (
            <ChoiceButton
              key={tenant.id}
              selected={tenant.id === selected?.id}
              onPress={() => {
                setSelected(tenant)
              }}
              mb={idx !== tenants.length - 1 ? 'large' : null}
            >
              {tenant.tenantName}
            </ChoiceButton>
          ))}
        </FlexColumn>
      </ModalContent>
      <StandardModalFooter onContinue={handleContinue} onClose={onClose} working={isInFlight} />
    </>
  )
}
